<template>
  <div>
    <div class="container">
      <div class="content">
        <div class="content-top">
          <div class="title">
            <div class="invoiceType">
              <div style="height: 40px;color:#b78468 ">
                {{
                  row.invoiceType == 1 || row.invoiceType == 2
                      ? invoiceType[row.invoiceType - 1].label
                      : "请选择"
                }}
              </div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </div>
          <div class="no">
            <div>
              <span>发票号码：</span>
              <span style="width: 150px; text-align: center;color: black;font-size: 12px">{{
                  row.invoiceNum
                }}</span>
            </div>
            <div class="font-label" style="height: 30px">
              开票日期：

              <span class="font-content" style="width: 120px;color: black">{{ row.addTime }}</span>
            </div>
          </div>
        </div>
        <div class="fp">
          <div style="width: 962px; display: flex; flex-direction: column">
            <div class="fp-top">
              <div class="gmf font-label right">购买方信息</div>
              <div class="gmf-content right">
                <div class="column">
                  <span class="gf-label">名称：</span>
                  <span class="fp-content">
                  {{ row.invoiceTitle }}
                </span>
                </div>
                <div class="column top">
                  <span class="gf-label">纳税人识别号：</span>
                  <span class="fp-content">{{ row.buyerTaxNum }}</span>
                </div>
              </div>
              <div class="gmf font-label right">销售方信息</div>
              <div class="gmf-content ">
                <div class="column">
                  <span class="gf-label">名称：</span>
                  <span class="fp-content" >{{ row.invoiceCompName }}</span>
                </div>
                <div class="column top">
                  <span class="gf-label">纳税人识别号：</span>
                  <span class="fp-content">{{ row.sellerTaxNum }} </span>
                </div>
              </div>
            </div>
            <div class="fp-goods">
              <div class="goods-column " style="width: 250px">
                <span class="font-label">项目名称</span>
                <span class="fp-content" style="margin-top: 5px" v-for="(item,index) in row.projectsList" :key="index">{{
                    item.projectName
                  }}</span>
                <span class="font-label" style="margin-top: auto">合计</span>
              </div>
              <div class="goods-column " style="width: 80px">
                <span class="font-label">单位</span>
                <span class="fp-content" style="margin-top: 5px" v-for="(item,index) in row.projectsList" :key="index">{{
                    item.unit
                  }}</span>
              </div>
              <div class="goods-column " style="width: 130px">
                <span class="font-label">数量</span>
                <span class="fp-content" style="margin-top: 5px" v-for="(item,index) in row.projectsList" :key="index">{{
                    item.counts
                  }}</span>
              </div>
              <div class="goods-column " style="width: 130px">
                <span class="font-label">单价</span>
                <span class="fp-content" style="margin-top: 5px" v-for="(item,index) in row.projectsList" :key="index">{{
                    item.price
                  }}</span>
              </div>
              <div class="goods-column " style="width: 130px">
                <span class="font-label">金额</span>
                <span class="fp-content" style="margin-top: 5px" v-for="(item,index) in row.projectsList" :key="index">{{
                    item.totalAmount
                  }}</span>
                <span class="font-label" style="margin-top: auto">{{ row.allTotalAmount }}</span>
              </div>
              <div class="goods-column " style="width: 80px">
                <span class="font-label">税率</span>
                <span class="fp-content" style="margin-top: 5px"
                      v-for="(item,index) in row.projectsList" :key="index">{{ item.taxRate }}%</span
                >
              </div>
              <div class="goods-column" style="width: 150px">
                <span class="font-label">税额</span>
                <span class="fp-content" style="margin-top: 5px" v-for="(item,index) in row.projectsList" :key="index">{{
                    item.taxAmount
                  }}</span>
                <span class="font-label" style="margin-top: auto">{{ row.allTaxAmount }}</span>
              </div>
            </div>
            <div class="fp-xm" style="flex-direction: column;">
              <div  style="display: flex;">


              <div class="goods-column" style="width: 200px">
                <span class="font-label">运输工具种类</span>
                <div class="line-two"></div>
              </div>
              <div class="goods-column " style="width: 120px">
                <span class="font-label">运输工具牌号</span>
                <div class="line-two"></div>

              </div>
              <div class="goods-column " style="width: 200px">
                <span class="font-label">起运地</span>
                <div class="line-two"></div>

              </div>
              <div class="goods-column " style="width: 200px">
                <span class="font-label">到达地</span>
                <div class="line-two"></div>

              </div>
              <div class="goods-column " style="width: 250px">
                <span class="font-label">运输货物名称</span>
                <div class="line-two"></div>
              </div>

              </div>
              <div style="flex: 1;
    overflow: auto;
}">
                <div v-for="(item,index) in row.goodList" :key="index" style="display:flex;">
                 <span style="width: 200px;display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;" >
                    <el-popover placement="bottom" width="180" trigger="click" >
                  <template #reference>
                    <span class="fp-content" >{{
                        item.contractBusType | contractBusType
                      }}</span>
                  </template>
                  <vxe-select v-model="item.contractBusType" placeholder="请选择" transfer clearable style="width: 150px">
                    <vxe-option value="1" label="水路运输"></vxe-option>
                    <vxe-option value="2" label="公路运输"></vxe-option>
                  </vxe-select>
                </el-popover>
                </span>
                  <span class="fp-content" style="width: 120px;display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;" >{{ item.carShipNum }}</span>
                  <span class="fp-content" style="width: 200px;display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;" ><span style="width: 190px;display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;">{{ item.beginPlace }}</span></span>
                  <span class="fp-content" style="width: 200px;display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;" ><span style="width: 190px;display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;">{{ item.endPlace }}</span></span>
                  <span class="fp-content" style="width: 250px;display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;" >{{
                      item.goodsName
                    }}</span>
                </div>
              </div>


            </div>
            <div class="fp-hj">
              <div class="goods-column right" style="width: 250px; justify-content: center">
                <span class="font-label">价税合计（大写）</span>
              </div>
              <div class="goods-column" style="width: 375px; justify-content: center">
                <span class="fp-content">{{
                    changeNumMoneyToChinese(Number(row.taxTotalAmount))
                  }}</span>
              </div>
              <div
                  class="goods-column"
                  style="width: 130px; align-items: flex-end; justify-content: center"
              >
                <span class="font-label">（小写）</span>
              </div>
              <div
                  class="goods-column"
                  style="width: 210px; align-items: flex-start; justify-content: center"
              >
                <span class="fp-content">¥ {{ Number(row.taxTotalAmount) }}</span>
              </div>
            </div>
            <div class="fp-bottom">
              <div class="bz font-label right">备注</div>
              <div class="bz-content">
                <div class="column" style="height: 100%; margin-top: 2px">
                  <div v-if="cate === 'Sales'">
                    <span
                        :title="row.note" class="fp-content text-overflow" style="width: 100%">{{
                        row.note
                      }}</span>
                  </div>
                  <div v-else style="margin-left: 10px;">
                    <div>
                       <span
                           :title="row.note" class="fp-content text-overflow" style="width: 100%">{{
                           row.note
                         }}</span>
                      <div v-if="row.replaceTaxpayer !=null" style="display: flex">
                        <div style="display: flex;align-items: center;width: 179px;">
                          <span>纳税人名称：</span>
                          <span class="font-content">{{
                              row.replaceTaxpayer
                            }}</span>
                        </div>
                        <div>
                          <span>纳税人证件号码：</span>
                          <span class="font-content">{{
                              row.repalceTaxNum
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-bottom">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getAuthOrization from "@/mixin/getAuthOrization";
import $C from "@/consts";
import $api from "@/apiProvider";
import {hideLoading, isEmpty, isNotEmpty, orderDetail, showLoading} from "@/utils/util";


const assign = (val) => Object.assign({}, val);
const empties = [undefined, "", null, "null", {}, []];

export default {
  mixins: [getAuthOrization],
  name: "Detail",
  components: {},
  props: {
    cate: {
      type: String,
      default: "",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    isUpdate: {
      type: Boolean,
      default: true,
    },
    isMatching: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dicByParentData: [],
      tax_rate: [],
      projectNameType: [],
      isShowChooseOrder: false,
      isShowChooseAccount: false,
      isShowChooseCarShip: false,
      isShowInvoiceAccount: false,
      invoiceType: $C.invoiceType.options,
      deductType: $C.deductType.options,
      isEdit: false,
      row: {
        manageAmount: null,
      },
      currentChooseColumn: "",
      tableData: [],
      editRules: {
        invoiceNum: [
          {
            validator: this.requireValid,
          },
        ],
        addTime: [
          {
            validator: this.requireValid,
          },
        ],
        invoiceCompName: [
          {
            validator: this.requireValid,
          },
        ],
        invoiceTitle: [
          {
            validator: this.requireValid,
          },
        ],
        goodsName: [
          {
            validator: this.requireValid,
          },
        ],
        taxRate: [
          {
            validator: this.requireValid,
          },
        ],
        taxAmount: [
          {
            validator: this.requireValid,
          },
        ],
        amount: [
          {
            validator: this.requireValid,
          },
        ],
      },
    };
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        //关闭弹窗
        if (val == false && oldVal == true) {
          this.isEdit = false;
        }
      },
    },
  },
  mounted() {

  },
  filters: {
    contractBusType: function (v) {
      if (v == 1) {
        return "水路运输"
      } else if (v == 2) {
        return "公路运输"
      } else {
        return "水路运输"
      }
    }

  },
  methods: {
    async queryCompUserList(name,type) {
      this.loading = true;
      if (name == null || name == ''){
        name = "-111"
      }
      let res = await $api.gcdUser.request("queryUserListWithoutPermission", {
        username: name,
        userType: 2,
        orderBy: 2,
        page: 1,
        rows: 100,
      });
      this.loading = false;
      if (res.status === 1) {
        if (type==1){
          if (res.data.rows.length == 0){
            this.row.buyerTaxNum = null;
          }
          else {
            this.row.buyerTaxNum = res.data.rows[0].taxNum;
          }
        }
        if (type==2){
          if (res.data.rows.length == 0){
            this.row.sellerTaxNum = null;
          }
          else {
            this.row.sellerTaxNum = res.data.rows[0].taxNum;
          }
        }

      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getCompanyList(name,type) {
      let params = {
        orderBy: 2,
        page: 1,
        rows: 100,
        name:name
      };
      let res = await $api.department.get("listCompany", params);
      this.loading = false;
      if (res.status === 1) {
        if (type==1){
          if (res.data.rows.length == 0){
            this.row.buyerTaxNum = null;
          }
          else {
            this.row.buyerTaxNum = res.data.rows[0].taxNum;
          }
        }
        if (type==2){
          if (res.data.rows.length == 0){
            this.row.sellerTaxNum = null;
          }
          else {
            this.row.sellerTaxNum = res.data.rows[0].taxNum;
          }
        }

      }
    },
     getDataByFinance(list) {
      let row = list;
      if (row.laydays != null) {
        row.laydays = this.$utils.toDateString(row.laydays, "yyyy-MM-dd");
      }
      if (row.addTime != null) {
        row.addTime = this.$utils.toDateString(row.addTime, "yyyy-MM-dd");
      }
      if (row.deductTime != null) {
        row.deductTime = this.$utils.toDateString(row.deductTime, "yyyy-MM-dd");
      }
      if (row.createTime != null) {
        row.createTime = this.$utils.toDateString(row.createTime, "yyyy年MM月dd日");
      }

      this.row = row;
      this.getCompanyList(row.invoiceCompName,2);
       this.queryCompUserList(row.invoiceTitle,1);
       console.log(row)
      this.tableData = [row];

    },
    getInvoiceTitle(val, index, row, type) {
      if (val) {
        this.row.rateDeduct = null;
        this.row.deductType = null;
        this.row.salesMan = null;
        this.row.rateManage = null;
        this.row.manageAmount = null;
      }
      if (type === "buyer") {
        this.row.buyerTaxNum = row.taxNum;
        this.row.buyerAddress = row.address;
        this.row.buyerMobile = row.mobile;
        this.row.buyerBankName = row.bankName;
        this.row.buyerAccountNum = row.accountNum;
      } else {
        this.row.sellerTaxNum = row.taxNum;
        this.row.sellerAddress = row.address;
        this.row.sellerMobile = row.mobile;
        this.row.sellerBankName = row.bankName;
        this.row.sellerAccountNum = row.accountNum;
      }
    },

    changeNumMoneyToChinese(money) {
      let cnNums = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"]; //汉字的数字
      let cnIntRadice = ["", "拾", "佰", "仟"]; //基本单位
      let cnIntUnits = ["", "万", "亿", "兆"]; //对应整数部分扩展单位
      let cnDecUnits = ["角", "分", "毫", "厘"]; //对应小数部分单位
      let cnInteger = "整"; //整数金额时后面跟的字符
      let cnIntLast = "元"; //整型完以后的单位
      let maxNum = 999999999999999.9999; //最大处理的数字
      let IntegerNum; //金额整数部分
      let DecimalNum; //金额小数部分
      let ChineseStr = ""; //输出的中文金额字符串
      let parts; //分离金额后用的数组，预定义
      let Symbol = ""; //正负值标记
      if (money === "") {
        return "";
      }
      money = parseFloat(money);
      if (money >= maxNum) {
        alert("超出最大处理数字");
        return "";
      }
      if (money === 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger;
        return ChineseStr;
      }
      if (money < 0) {
        money = -money;
        Symbol = "负 ";
      }
      money = money.toString(); //转换为字符串
      if (money.indexOf(".") === -1) {
        IntegerNum = money;
        DecimalNum = "";
      } else {
        parts = money.split(".");
        IntegerNum = parts[0];
        DecimalNum = parts[1].substr(0, 4);
      }
      if (parseInt(IntegerNum, 10) > 0) {
        //获取整型部分转换
        let zeroCount = 0;
        let IntLen = IntegerNum.length;
        for (let i = 0; i < IntLen; i++) {
          let n = IntegerNum.substr(i, 1);
          let p = IntLen - i - 1;
          let q = p / 4;
          let m = p % 4;
          if (n === "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              ChineseStr += cnNums[0];
            }
            zeroCount = 0; //归零
            ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m === 0 && zeroCount < 4) {
            ChineseStr += cnIntUnits[q];
          }
        }
        ChineseStr += cnIntLast;
        //整型部分处理完毕
      }
      if (DecimalNum !== "") {
        //小数部分
        var decLen = DecimalNum.length;
        for (let i = 0; i < decLen; i++) {
          let n = DecimalNum.substr(i, 1);
          if (n !== "0") {
            ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (ChineseStr === "") {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (DecimalNum === "") {
        ChineseStr += cnInteger;
      }
      ChineseStr = Symbol + ChineseStr;

      return ChineseStr;
    },
  },
};
</script>
<style scoped>
.container {
  background: #ffffff;
  padding: 25px 65px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.content {
  width: 1041px;
  /*height: 641px;*/
  border: 1px solid #cccccc;
  box-sizing: border-box;
  padding-bottom: 10px;
}

.content-top {
  height: 110px;
  /*background: url("~assets/images/common/yz.png") center no-repeat;*/
  padding-top: 25px;
  position: relative;
}

.title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.line {
  margin-top: 5px;
  width: 310px;
  height: 2px;
  background: #b78468;
}

.line-two {
  width: 100%;
  margin-top: 2px;
  height: 2px;
  background: #b78468;
}

.invoiceType {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 600;
  color: #231815;
}

.no {
  position: absolute;
  right: 38px;
  top: 25px;
  display: flex;
  flex-direction: column;
}

.no span {
  /*margin-left: 10px;*/
  /*font-size: 24px;*/
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 400;
  color: #b78468;
}

.tip {
  width: 850px;
  height: auto;
  position: relative;
  margin-top: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.bottom-tip {
  margin-top: 5px;
  padding: 0 50px;
  display: flex;
  align-items: center;
}

.font-label {
  /*font-size: 16px;*/
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: #b78468;
  display: flex;
  align-items: center;
}

.gf-label {
  /*font-size: 16px;*/
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: #b78468;
  /*min-width: 115px;*/
}

.or-label {
  /*font-size: 16px;*/
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: #b78468;
  min-width: 90px;
}

.bz-label {
  /*font-size: 16px;*/
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: #b78468;
  min-width: 52px;
}

.fp-content {
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: black;
}

.font-content {
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: black;
  line-height: 40px;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fp {
  width: 965px;
  height: 564px;
  border: 2px solid #b78468;
  margin-left: 40px;
  margin-top: 2px;
  display: flex;
}

.fp-top {
  display: flex;
  height: 110px;
  border-bottom: 2px solid #b78468;
}

.bottom-border {
  border-bottom: 2px solid #b78468;
}

.fp-bottom {
  display: flex;
  height: 100%;
}

.fp-goods {
  display: flex;
  min-height: 160px;
  border-bottom: 2px solid #b78468;
}

.fp-xm {
  display: flex;
  min-height: 160px;
  border-bottom: 2px solid #b78468;
}

.fp-hj {
  display: flex;
  min-height: 40px;
  border-bottom: 2px solid #b78468;
}

.right {
  border-right: 2px solid #b78468;
}

.gmf {
  line-height: 18px;
  width: 32px;
  padding: 0px 8px;
  box-sizing: border-box;
  /*font-size: 20px;*/
}

.ddxx {
  width: 32px;
  padding: 0px 5px;
  box-sizing: border-box;
  font-size: 18px;
}

.bz {
  width: 32px;
  padding: 15px 5px;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 40px;
}

.gmf-content {
  width: 430px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding-left: 15px
}

.ddxx-content {
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
}

.bz-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.column {
  display: flex;
  align-items: center;
  padding-right: 5px;
}

.top {
  margin-top: 2px;
}

.goods-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.vxe-input {
  font-size: 14px;
  height: 23px;
}

.goods-column >>> .vxe-input, .font-label >>> .vxe-input {
  height: 23px;
}

.container >>> .vxe-input--inner {
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: #878787;
}

.plateForm >>> .link-text {
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: #878787;
}

.salesMan >>> .link-text {
  width: 110px;
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: #878787;
}

.link-text {
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: #878787;
}

.invoiceType >>> .vxe-input {
  height: 40px;
}

.invoiceType >>> .vxe-input--inner {
  font-size: 26px;
  font-family: sans-serif;
  font-weight: 400;
  color: #b78468;
  text-align: center;
}

.no >>> .vxe-input--inner {
  /*font-size: 24px;*/
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 400;
  /*color:#878787;*/
}

.fp-right {
  font-size: 16px;
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: #352e2c;
  width: 20px;
  margin: 80px 0 0 5px;
  line-height: 24px;
  word-wrap: break-word;
}

.kd {
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  /*font-weight: 600;*/
  color: #352e2c;
  display: flex;
  align-items: center;
}

.content-bottom {
  display: flex;
  justify-content: center;
}
</style>
